import styled from 'styled-components';
import { colors, spacing, transitions, typography } from '../../styles/theme';
import BaseBox from '../../components/ui/Box';

export const Container = styled.div`
  margin: 0px auto;
  max-width: 800px;
`;

export const Header = styled.header`
  width: 100%;
  margin: ${spacing('8')} 0 ${spacing('4')} 0;
`;

export const Title = styled.h1`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-size: 80px;
  font-weight: ${typography('weights.bold')};
  color: ${colors('black.base')};
`;

export const Actions = styled.div`
  margin: ${spacing('6')} 0;
  display: flex;
  align-items: center;

  a {
    transition: ${transitions('fast')};
    height: 23px;
    display: flex;
    align-items: center;
    &:not(.disabled-link):hover {
      background-color: ${colors('black.base')};
      color: ${colors('default.base')};
      transition: ${transitions('fast')};
    }
  }
`;

export const Action = styled.button`
  display: block;
  margin-left: auto;
  margin-bottom: 6px;
  cursor: pointer;
  padding: 6px 8px;
  font-weight: bold;
  font-size: 12px;
  text-transform: uppercase;
  background-color: white;
  border: none;
  border-radius: 6px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
`;

export const Box = styled(BaseBox)`
  margin: ${spacing('1')} 0;

  p {
    margin-bottom: ${spacing('1')};
    font-weight: ${typography('weights.semibold')};
  }

  i {
    font-size: 20px;
    color: #d22;
    position: relative;
    top: ${spacing('small')};
    left: -${spacing('extraSmall')};
  }
`;

export const Error = styled(BaseBox)`
  margin-top: ${spacing('2')};

  p {
    font-weight: ${typography('weights.semibold')};
  }

  i {
    font-size: 20px;
    color: #d22;
    position: relative;
    top: ${spacing('small')};
    left: -${spacing('extraSmall')};
  }
`;

export const List = styled.ul`
  margin: 16px 18px;
  font-weight: 500;
  list-style: initial;
`;
